import { render, staticRenderFns } from "./finance-ptsytx-list.vue?vue&type=template&id=238afcce&scoped=true&"
import script from "./finance-ptsytx-list.vue?vue&type=script&lang=js&"
export * from "./finance-ptsytx-list.vue?vue&type=script&lang=js&"
import style0 from "./finance-ptsytx-list.vue?vue&type=style&index=0&id=238afcce&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "238afcce",
  null
  
)

export default component.exports